export const HIGHLIGHT_CLASS = 'jb-highlight'
export const HIGHLIGHT_ACTIVE_CLASS = 'jb-highlight--active'
export const SNIPPET_HIGHLIGHT_CLASS = 'jb-highlight--snippet'

export const HIGHLIGHT_TERM = 'highlight_term'
export const HIGHLIGHT_SLUG = 'highlight_slug'
